import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import { Card, Container } from 'react-bootstrap';
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loading, PageHeader } from "wup-module1-base";
import { MeetingList } from "../../Components/List";
import UserContext from "../../Contexts/UserContext";
import { ClientService } from "../../Services";
import { PageTitleConstants } from "../../Constants";
import { Button } from "react-bootstrap";
import { AlertWarning } from "../../Components/Alert";

const Meetings = () => {
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(true);
    const [meetings, setMeetings] = useState([]);

    const goBack = () => {
        navigate(`/`);
    };

    function cancelMeetings(data, onSuccess) {
        ClientService.cancelMeetingsForClient(user.id, data)
            .then((response) => {
                onSuccess();
            })
            .catch((error) => {
            console.error(error);
            });
    }
    

    useEffect(() => {
        (async () => {
            const response = await ClientService.getCalendarMeeting(user.id);

            setMeetings(response.data);
            setIsLoading(false);
        })();
    }, []);

    return (
        <Container className="meetings-page">
            <PageHeader content={PageTitleConstants.Meetings} />
            <Card className="p-2 summary-card survey-screen application-form card">
                {meetings.length === 0 ? <AlertWarning children={'Nie jesteś przypisany do żadnych spotkań w systemie.'}></AlertWarning> : <div class="declaration-info">
                    <div className="info-container">
                        <div className="description-element">
                        <FontAwesomeIcon
                            icon={faStar}
                            className="description-icon mt-1"
                        />
                        <div class="description-paragraph" data-id="33:ds">
                            <div>
                                Oto lista wszystkich spotkań, w których uczestniczysz. Jeżeli chcesz odwołać udział w danym spotkaniu, to zaznacz check-box i kliknij przycisk <strong>„Odwołaj udział”</strong> poniżej
                            </div>
                        </div>
                        </div>
                    </div>
                </div>}
                {isLoading && <Loading />}
                {!isLoading && <MeetingList meetings={meetings} setMeetings={setMeetings} cancelMeetings={cancelMeetings}/>}
                <Card.Footer className="bg-white">
                    <Button
                        className="btn-back"
                        variant="secondary mr-1"
                        onClick={goBack}
                    >
                        Powrót
                    </Button>
                </Card.Footer>
            </Card>
        </Container>
    )
}

export default Meetings;
